export const getPathMonthDateRange = (pathname) =>
  ({
    '/expenses': 3,
    '/travels': 3,
    '/holidays': 3,
    '/expensesheets': 12,
    '/rejectedexpensesheets': 12,
  }[pathname] ?? 1);
